import styled, { css } from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

import TooltipLinkItem from "app/components/React/Table/tooltips/components/TooltipLinkItem/TooltipLinkItem";
import { capitalizeFirstLetter } from "app/pages/sales-intelligence/common-components/styles";
import type { CSSColor } from "app/pages/sales-intelligence/types/styles";

const buttonGradient = (...colors: CSSColor[]) => {
    const [c1, c2, c3, c4, c5, c6] = colors;

    return `
      radial-gradient(100% 177.78% at 100% 0%,
      ${c1} 0.05%,
      ${c2} 6.02%,
      ${c3} 26.04%,
      ${c4} 41.67%,
      ${c5} 76.56%,
      ${c6} 99.9%)`;
};

export const StyledTooltipButtonLink = styled(TooltipLinkItem)<{ isDisabled?: boolean }>`
    ${mixins.setFontVariant("button")};

    color: ${colorsPalettes.carbon[0]} !important;
    justify-content: center;
    flex: 1;
    padding: 16px 24px;

    ${({ isDisabled = false }) => {
        if (isDisabled) {
            return css`
                background: ${colorsPalettes.carbon[200]};
                pointer-events: none;
            `;
        }

        return css`
            background: ${buttonGradient("#6cb9ff", "#61abfd", "#4c8ffa", "#3b7af8", "#2862f5", "#265ff5")};
        `;
    }};

    &:hover,
    &:active {
        background: ${buttonGradient("#86c5ff", "#83beff", "#75aaff", "#6397ff", "#487bfc", "#4678fb")};
    }
`;

export const StyledTooltipButtonLinkText = styled.span`
    ${capitalizeFirstLetter};
`;
